import React, { useContext, useMemo } from 'react'

import type { LinkDetail } from '@vividseats/vivid-ui-kit'

import PerformerContext from '@/context/performer'

import PerformerLinks from '../component'
import { getSortedPerformerLinks } from '../utils'

interface SortedPerformerLinksProps {
    title: string
    variant?: 'LinkBank' | 'LinkWidget'
    performerNameSuffix?: string
}

const SortedPerformerLinks: React.FC<SortedPerformerLinksProps> = ({
    title,
    variant = 'LinkBank',
    performerNameSuffix = '',
}) => {
    const { state: performersState } = useContext(PerformerContext)

    const sortedPerformerLinks: LinkDetail[] = useMemo(
        () => getSortedPerformerLinks(performersState.data?.items ?? [], performerNameSuffix),
        [performersState.data?.items, performerNameSuffix],
    )

    const variantComponent = useMemo(() => {
        return <PerformerLinks title={title} variant={variant} links={sortedPerformerLinks} />
    }, [variant, title, sortedPerformerLinks])

    return variantComponent
}

export default SortedPerformerLinks
